export type ParsedSlots = number[];

const SAFE_CHARS = /^[\d,\s-]+$/;

function isFiniteNumber(v: unknown): v is number {
  return typeof v === 'number' && Number.isFinite(v);
}

export function normalizeSlotSpec(raw: string): string {
  return raw
    .trim()
    .replace(/\s\s+/g, ' ')
    .replace(/--+/g, '-')
    .replace(/,,+/g, ',');
}

function expandRange(part: string): number[] {
  const [aRaw, bRaw] = part.split('-').map((n) => parseInt(n.trim(), 10));

  if (!isFiniteNumber(aRaw) || !isFiniteNumber(bRaw)) {
    return [];
  }

  const start = Math.min(aRaw, bRaw);
  const end = Math.max(aRaw, bRaw);

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}

export function parseSlotSpec(
  spec: string | number | null | undefined
): ParsedSlots {
  if (spec == null) return [];

  const s = typeof spec === 'number' ? String(spec) : normalizeSlotSpec(spec);

  if (!s || !SAFE_CHARS.test(s)) return [];

  const parts = s
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean);

  const result: number[] = [];

  for (const part of parts) {
    if (part.includes('-')) {
      result.push(...expandRange(part));
    } else {
      const v = parseInt(part, 10);
      if (isFiniteNumber(v)) {
        result.push(v);
      }
    }
  }

  return Array.from(new Set(result)).sort((x, y) => x - y);
}

export function getRangeSize(spec: string | number | null | undefined): number {
  return parseSlotSpec(spec).length || 0;
}
